export default [
    {
        // [1]
        key: "code",
        label: app.$i18n.t("Code"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [1]
        key: "Approveds",
        label: app.$i18n.t("Approveds"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [2]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
];